import { useState } from 'react';

type TResponse = {
    isValid: boolean;
}

function useValidateStateObj<T extends Record<string, any>>(initialValue: T): TResponse {
    const isnotValid =  Object.values(initialValue).some(value => {
        return value == null || value === '' || (Array.isArray(value) && value.length === 0);
    });

    return { isValid: !isnotValid };
}

export default useValidateStateObj;
